<template>
  <div class="passenger-box">
    <div class="pass-header">
      <span class="h-strong"> <l8-icon class="l8-icon" type="icon-lvke"/>
 旅客{{ +index + 1 }}</span>
      <span class="h-msg">
          <span>{{ passenger.fullName }}</span>
          <span>{{ passenger.certificateTypeCn }}：{{ passenger.certificateNo | codeMask({offset: 4, length: 10}) }}</span>
          <span>联系电话：{{ passenger.mobile | codeMask }}</span>
          <span class="int-total-fare" v-if="ifInternational?.()">
            <tax-popover :passenger="passenger" :ifInternational="ifInternational?.()"></tax-popover>
          </span>
      </span>
      <!-- <span class="h-actions" v-if="editAble">
        <span class="h-action" @click="passengerEditHandler(passenger)"><i class="l8-icon l8-icon-edit"></i></span>
      </span> -->
    </div>
    <div class="pass-seg-list">
      <SegmentBox
        v-for="(seg, segIndex) in passenger.flightSegments"
        :key="segIndex"
        :order="order"
        :passenger="passenger"
        :seg="seg"
        :select-able="selectAble"
        :cmsData="cmsData"
        v-bind="$attrs"
        v-on="$listeners"
        @seg-change="onChange($event, passenger, seg)"
      ></SegmentBox>
    </div>
    <div class="pass-infants" v-if="infants.length">
      <PassengerInfants
        :order="order"
        :infants="infants"
        :select-able="selectAble"
        v-bind="$attrs"
        @seg-change="onChange"
      >
      </PassengerInfants>
      <div class="pass-infants-notice" v-if="cmsData.passengerInfTips" v-html="cmsData.passengerInfTips"></div>
    </div>
  </div>
</template>

<script>
import '@/components/l8-icon'
import '@/assets/css/l8-order-common.less'
import _ from 'lodash'

import SegmentBox from './SegmentBox.vue'
import PassengerInfants from './PassengerInfants.vue'
import taxPopover from './tax-popover.vue'

export default {
  name: 'PassengerBox',
  props: {
    passenger: {
      type: Object
    },
    index: {
      type: [Number, String]
    },
    order: {
      type: Object
    },
    cmsData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    }
  },
  computed: {
    // editAble: function () {
    //   return this.$attrs['edit-able'] !== 'undefined' ? this.$attrs['edit-able'] : true
    // },
    selectAble: function () {
      return typeof this.$attrs['select-able'] !== 'undefined' ? this.$attrs['select-able'] : true
    }
  },
  data () {
    return {
      infants: []
    }
  },
  created () {
    let copyInfant = JSON.parse(JSON.stringify(this.passenger.infantTravelers || []))

    _.each(copyInfant, (infant) => {
      _.each(infant.flightSegments, (infantSeg) => {
        infantSeg.checked = false
      })
    })

    this.infants = copyInfant
  },
  methods: {
    passengerEditHandler (pass) {
      this.$emit('edit', pass)
    },
    onChange (e, passenger, seg) {
      const self = this
      // TODO: 待完善，国内中转未考虑
      // 国际票同一旅客勾选一段即选中所有行程，包括中转和往返
      // if (this.ifInternational?.()) {
      //   _.each(self.passenger.flightSegments, (adultSeg) => {
      //     if (adultSeg.status !== 'XX') {
      //       self.$emit('select', self.passenger, adultSeg, e.target.checked)
      //       adultSeg.checked = e.target.checked
      //     }
      //   })

      //   if (this.infants && this.infants.length) {
      //     _.each(this.infants, (infant) => {
      //       _.each(infant.flightSegments, (infantSeg) => {
      //         if (['RR', 'HK', 'HL'].indexOf(infantSeg.status) >= 0) {
      //           this.$emit('select', infant, infantSeg, e.target.checked)
      //           infantSeg.checked = e.target.checked
      //         }
      //       })
      //     })
      //   }
      // }

      if (passenger.type === 'INFANT') {
        if (e.target.checked) {
          _.each(this.infants, (infant) => {
            _.each(infant.flightSegments, (infantSeg) => {
              if (seg.departureCode === infantSeg.departureCode && seg.flightNo === infantSeg.flightNo && ['RR', 'HK', 'HL'].indexOf(infantSeg.status) >= 0) {
                this.$emit('select', infant, infantSeg, e.target.checked)
                infantSeg.checked = e.target.checked
              }
            })
          })
        } else { // 婴儿取消时，对应成人也取消
          _.each(self.passenger.flightSegments, (adultSeg) => {
            if (seg.departureCode === adultSeg.departureCode && seg.flightNo === adultSeg.flightNo && adultSeg.status !== 'XX') {
              self.$emit('select', self.passenger, adultSeg, false)
              adultSeg.checked = false
            }
          })

          _.each(this.infants, (infant) => {
            _.each(infant.flightSegments, (infantSeg) => {
              if (seg.departureCode === infantSeg.departureCode && seg.flightNo === infantSeg.flightNo && ['RR', 'HK', 'HL'].indexOf(infantSeg.status) >= 0) {
                this.$emit('select', infant, infantSeg, e.target.checked)
                infantSeg.checked = e.target.checked
              }
            })
          })
        }
      } else {
        this.$emit('select', passenger, seg, e.target.checked)
        seg.checked = e.target.checked
        if (this.infants && this.infants.length) {
          _.each(this.infants, (infant) => {
            _.each(infant.flightSegments, (infantSeg) => {
              if (seg.departureCode === infantSeg.departureCode && seg.flightNo === infantSeg.flightNo && ['RR', 'HK', 'HL'].indexOf(infantSeg.status) >= 0) {
                this.$emit('select', infant, infantSeg, e.target.checked)
                infantSeg.checked = e.target.checked
              }
            })
          })
        }
      }
    }
  },
  components: {
    SegmentBox,
    PassengerInfants,
    taxPopover
  }
}
</script>
